import { IP_LOCATION_SET_ERROR, IP_LOCATION_SET_DATA } from './IP-location.constants';
import { Dispatch } from 'types/dispatch';
// services
import { UbisoftAPIService } from 'modules/ubisoft-api';
import { ICountryCode } from 'modules/ubisoft-api/ubisoft-api.types';

const setIPLocationData = (payload: ICountryCode) => ({
    type: IP_LOCATION_SET_DATA,
    payload
});

const setIPLocationError = (payload: Error) => ({
    type: IP_LOCATION_SET_ERROR,
    payload
});

export const IPLocationFetchData = () => (dispatch: Dispatch, getState: Function) => {
    const { config } = getState();
    UbisoftAPIService.configure({
        appId: config.applicationId,
        env: config.envName
    });
    return UbisoftAPIService.getIPLocation()
        .then(response => {
            dispatch(setIPLocationData(response));
        })
        .catch(error => {
            dispatch(setIPLocationError(error));
        });
};

export type Actions = ReturnType<typeof setIPLocationData> | ReturnType<typeof setIPLocationError>;
